<ng-container *ngIf="!isCurrencyMask && !customInput">
    <input  
        *ngIf="!phoneInputMask"
        #inputName
        [formControl]="controlName"       
        (focus)="setAutocomplete(autocomplete)"
        [placeholder]="placeholder" 
        [maxLength]="maxLength" 
        [type]="type"  
        class="form-control form-control--paybee"
        [attr.autocomplete]="autocomplete ? autocomplete : null"
        [attr.readonly]="readonly ? '': null"
        (click)='onContainerClick($event)'
        (blur)="onBlur()" 
    />
    <input  
        *ngIf="phoneInputMask"
        #inputName
        [formControl]="controlName"       
        (focus)="setAutocomplete(autocomplete)"
        [placeholder]="placeholder" 
        [maxLength]="maxLength" 
        [type]="type"  
        class="form-control form-control--paybee"
        [attr.autocomplete]="autocomplete ? autocomplete : null"
        (click)='onContainerClick($event)'
        (blur)="onBlur()"
        [inputMask]="phoneMask"
        [attr.readonly]="readonly ? '': null"
    />        
</ng-container> 
<ng-content></ng-content>
<label *ngIf="!customInput" mdbLabel class="form-label form-label--paybee" for="inputControl">{{label}}</label> 
<span *ngIf="focused && showMaxLength" class="character-counter character-counter--paybee">{{value?.length}}/{{maxLength}}</span>
